exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animation-logo[data-v-7b2e90c9]{width:300px}@media screen and (max-width:600px){.animation-logo[data-v-7b2e90c9]{width:100px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b2e90c9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/animations/Loader.vue
// module id = 395
// module chunks = 0